import { Outlet, createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { NotFoundPage } from '@/components/NotFoundPage';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';
import { BusTimesPage } from '@/features/stop-selection/BusTimesPage';
import { StopPickerPage } from '@/features/stop-selection/StopPickerPage';
import { ScheduleCachePage } from '@/features/schedule/ScheduleCachePage';
import type { AppEntry } from '@/app/routes-types';

export const entry: AppEntry = { default: '/', byRole: {} };

const rootRoute = createRootRoute({
  component: Outlet,
  notFoundComponent: NotFoundPage,
});

const busTimesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: BusTimesPage,
  beforeLoad: () => guardSurface(entry, SURFACES['bus-times']),
  staticData: { title: 'Bus times', page: SURFACES['bus-times'], standalone: false, isPublic: true },
});

const stopPickerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'stops',
  component: StopPickerPage,
  beforeLoad: () => guardSurface(entry, SURFACES['stop-picker']),
  staticData: { title: 'Choose a stop', page: SURFACES['stop-picker'], standalone: false, isPublic: true },
});

const scheduleCacheRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'schedules',
  component: ScheduleCachePage,
  beforeLoad: () => guardSurface(entry, SURFACES['schedule-cache']),
  staticData: { title: 'Schedule data', page: SURFACES['schedule-cache'], standalone: false, isPublic: true },
});

const routeTree = rootRoute.addChildren([busTimesRoute, stopPickerRoute, scheduleCacheRoute]);

export const router = createRouter({ routeTree, notFoundMode: 'root' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
